export default __webpack_public_path__ + "static/media/No.4-2.eb999893.jpg";